import { jsx as _jsx } from "react/jsx-runtime";
import { CatSearchForm } from '@blocks-react/components/SearchForm';
export const MyEquipmentSearch = ({ placeholder, onSearch, dataCsMask, size = 'md', ...searchFormProps }) => {
    return (_jsx(CatSearchForm, { mobileBreakPoint: 0, size: size, placeholder: placeholder, isEmpty: true, "data-testid": "myEquipmentSearch", onBlChange: (e) => {
            onSearch && onSearch(e.detail.value ?? '');
        }, "data-cs-mask": dataCsMask, ...searchFormProps }));
};
